// extracted by mini-css-extract-plugin
export default {"dvir-defect-info-cell":"UnresolvedDriverDvirDefects_dvir-defect-info-cell__TqbQd"};